import { useState } from 'react';
export default function useToAndEndDate(start, end) {
    const [startDate, setStartDate] = useState(start);
    const [endDate, setEndDate] = useState(end);
    return { setEndDate, setStartDate, startDate, endDate };
}
